// ============================================================================
// LEGACY JAVASCRIPT FROM ELEMENTOR CUSTOM CODE
// ============================================================================
// This file contains legacy JavaScript that was in Elementor Custom Code
// These scripts are needed for Elementor page compatibility
// DO NOT ADD NEW CODE HERE - use proper JS modules in /components/ instead
// This will be removed when Elementor is fully deprecated
// ============================================================================

/* Fix Elementor issue which prevents accessibility skip links from working */
const main = document.querySelector('main')
if (main && !main.id) {
  main.id = 'content'
}

// Card overlay functionality with safeguards to prevent duplicate event listeners
(function () {
  // Track if we've already initialized
  let initialized = false

  function initCardOverlays () {
    if (initialized) {
      return
    }
    initialized = true

    // Use event delegation for all card interactions
    document.addEventListener('click', (e) => {
      // Early return if not clicking on relevant elements
      if (!e.target || !e.target.classList) {
        return
      }

      // Handle overlay open
      if (e.target.classList.contains('overlay-open') ||
        (e.target.closest && e.target.closest('.overlay-open'))) {
        e.preventDefault()

        const openElement = e.target.classList.contains('overlay-open')
          ? e.target
          : e.target.closest('.overlay-open')
        const card = openElement.closest('.card')
        if (!card) {
          return
        }

        const overlay = card.querySelector('.overlay')
        if (overlay) {
          overlay.classList.add('active')
        }
      }

      // Handle overlay close
      if (e.target.classList.contains('overlay-close') ||
        (e.target.closest && e.target.closest('.overlay-close'))) {
        e.preventDefault()

        const closeElement = e.target.classList.contains('overlay-close')
          ? e.target
          : e.target.closest('.overlay-close')
        const parentOverlay = closeElement.closest('.overlay')
        if (parentOverlay) {
          parentOverlay.classList.remove('active')
        }
      }
    })
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardOverlays)
  } else {
    initCardOverlays()
  }

  // For Elementor's AJAX filtering - check if jQuery is loaded
  if (typeof window.jQuery !== 'undefined') {
    window.jQuery(document).on('elementor/ajax/request/success', () => {
      // We don't need to reinitialize since we're using event delegation
      // and we're preventing duplicate initialization
    })
  }
})()
